import React, { useEffect, useState } from "react";
import { History, ArrowRight } from "lucide-react";
import api, { TRY } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function PriceHistoryDialog({ customer, onClose }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!customer) return;
    setRows(null);
    api.get(`/customers/${customer.id}/price-history`).then((r) => setRows(r.data));
  }, [customer]);

  return (
    <Dialog open={!!customer} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="price-history-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <History className="h-5 w-5 text-primary" /> Fiyat Geçmişi
          </DialogTitle>
        </DialogHeader>
        <div className="text-sm text-muted-foreground -mt-1">{customer?.short_name || customer?.name}</div>
        <div className="mt-2 space-y-2 max-h-80 overflow-y-auto">
          {rows === null && <div className="text-sm text-muted-foreground py-6 text-center">Yükleniyor…</div>}
          {rows?.length === 0 && <div className="text-sm text-muted-foreground py-6 text-center">Kayıt yok</div>}
          {rows?.map((h, i) => (
            <div key={h.id} data-testid={`price-history-row-${i}`} className={`rounded-lg border px-3 py-2.5 ${i === 0 ? "border-primary/40 bg-primary/5" : "border-border"}`}>
              <div className="flex items-center justify-between">
                <div className="font-mono text-sm flex items-center gap-2">
                  {h.old_price != null ? (
                    <><span className="text-muted-foreground line-through">{TRY(h.old_price)}</span>
                      <ArrowRight className="h-3.5 w-3.5 text-muted-foreground" /></>
                  ) : null}
                  <span className="font-bold">{TRY(h.new_price)}</span>
                </div>
                {i === 0 && <span className="text-[10px] uppercase font-semibold text-primary">Güncel</span>}
              </div>
              <div className="text-[11px] text-muted-foreground mt-1">
                {new Date(h.changed_at).toLocaleString("tr-TR", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                {h.note && <> · {h.note}</>}
                {h.changed_by && h.changed_by !== "sistem" && <> · {h.changed_by}</>}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
